import React from 'react';
import { Helmet } from 'react-helmet';

// Only an explicit `false` yields `noindex`: SSR and the API deploy separately, and a
// response predating the field must not de-index a page that is in the index today.
export const getRobotsContent = (indexable: boolean): 'index' | 'noindex' =>
  indexable === false ? 'noindex' : 'index';

// `indexable` is required rather than defaulted so that a new landing page has to state
// whether it belongs in the index, and the node is emitted in both states so the served
// answer is readable from the page source instead of inferred from a missing tag.
const LandingHelmet: React.FC<{
  title: string;
  metaDescription: string;
  indexable: boolean;
  children?: React.ReactNode;
}> = ({ title, children, metaDescription, indexable }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={metaDescription} />
      <meta property="og:description" content={metaDescription} />
      <meta name="robots" content={getRobotsContent(indexable)} />
      {children}
    </Helmet>
  );
};

export default LandingHelmet;
